import { render, staticRenderFns } from "./LanguageInput.vue?vue&type=template&id=ee7d6944&scoped=true"
import script from "./LanguageInput.vue?vue&type=script&lang=js"
export * from "./LanguageInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7d6944",
  null
  
)

export default component.exports